module.exports = __webpack_public_path__ + "img/bvnwarn.8ff14da2.svg";